const webPImage = fileName => {
  if (!fileName) {
    return null
  }

  return fileName.replace(/(\.png|\.jpg|\.jpeg|\.gif)$/, '.webp')
}

export default webPImage
